
import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, Sanitizer, SecurityContext, DOCUMENT, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { HTTPService } from 'src/app/services/http.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import { Subscription } from 'rxjs';
import { CryptoServices } from 'src/app/services/CryptoServices';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { AmazonServices } from 'src/app/services/AmazonServices';
import { HttpErrorResponse } from '@angular/common/http';
import { SearchProperties } from 'src/app/system-utils/search-input-new/search-input-new.component';
import { LanguageServices } from 'src/app/services/LanguageServices';
import { NzModalComponent } from 'ng-zorro-antd/modal';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ParamInjectorServices } from 'src/app/services/ParamInjectorServices';

export interface OAuthConfiguration{
    codemktp:number;
    name:string;
    generic:boolean|false;
    icon:string;
    bgColor?:string;
    autenticado?:boolean;
    expirado?:boolean;
    erro?:boolean;
    urlAuth?:string;
    redirectUri?:string;
    checkData?:boolean;
    waiting?:boolean;
    additionalFields?:OAuthAdditionalFields[],
    tokenStatusService?:string;
    tokenGenerateService?:string;

}

export interface OAuthAdditionalFields{
    name:string;
    label:string;
    type:string;
}


@Component({
    selector: 'authentication',
    templateUrl: './authentication_v2.component.html',
    styleUrls: ['./authentication.component.scss'],
    standalone: false
})
export class ExternalAuthenticationComponent implements OnInit, OnDestroy {

  
  interval: NodeJS.Timeout;
  url: any | URL;
  appToken: any = null;
  codemktp: any| number = null;
  codecompany:  {key:number; value:any} = {key: 0, value: ''};
  //isGeneric = false;
  marketPlaceName: any;
  activecompanies:Object;
  marketplacelist:OAuthConfiguration[] = [
     //{codemktp:62, name:"Amazon PII",generic: false, icon:'amazon', bgColor:'#000000',autenticado:true,expirado:false,erro:false}
    {codemktp:47, name:"Shopee",generic: false,icon:'shopee',autenticado:true, expirado:true,additionalFields:[
        {
          name: "testMode",
          label: "authentication.testMode",
          type:  "switch"
        }
      ]}
    ,{codemktp:121, name:"Sankhya",generic: false,icon:'sankhya',autenticado:false, additionalFields:[
        {
          name: "username",
          label: "username",
          type:  "password"
        },
        {
          name: "password",
          label: "password",
          type:  "password"
        }
    ], 
    tokenStatusService:null,
    tokenGenerateService:"SystemServices/encryptData"
  }
  ];
  nickname: string;
  sub:Subscription;
  sub1:Subscription;
  sub2:Subscription;
  sub3:Subscription;
  sub4:Subscription;
  sub5:Subscription;
  sub6:Subscription;
  hide:boolean = true;
  isTestMode = false;
  amazonprogramacode: number;
  username:string = "";
  password:string = "";
  amazonprograma:{code:number,name:string}[] = [{code:0,name:'Autenticação SP-API'},{code:1,name:'FBA OnSite'}];
  

  constructor(
              private http:HTTPService, 
              public us:UserAuthenticationServices,
              private cd:ChangeDetectorRef,
              private crypto:CryptoServices,
              private AmazonServices:AmazonServices,
              private ls:LanguageServices,
              private fb:FormBuilder,
              private paramInjector: ParamInjectorServices,
              private message: NzMessageService) { }
  
  
  ngOnDestroy(): void {
    clearInterval(this.interval);
    if (this.sub!= null ) {this.sub.unsubscribe();}
    if (this.sub1!= null ) {this.sub1.unsubscribe();}
    if (this.sub2!= null ) {this.sub2.unsubscribe();}
    if (this.sub3!= null ) {this.sub3.unsubscribe();}
    if (this.sub4!= null ) {this.sub4.unsubscribe();}
    if (this.sub5!= null ) {this.sub5.unsubscribe;}
    if (this.sub6!= null ) {this.sub6.unsubscribe();}
  }

  onOAuthSuccess(){
    if ( this.selected ){
      this.selected.checkData = true;
      this.selected.waiting = true;
      this.cd.markForCheck();
    }
  }

  onOAuthError(reason:string){
    if ( this.selected ){
      this.selected.checkData = false;
      this.selected.waiting = false;
      this.selected.erro = true;
      
      this.message.error(this.ls.instant("authentication.oauthError")+ ": " + reason);
    }
  }

  ngOnInit(): void {

    this.paramInjector.injectParams(this);
    

    window.addEventListener("message", (event) => {
      if (event.data?.status === "success") {
        this.onOAuthSuccess();
      }

      if (event.data?.status === "error") {
        this.onOAuthError(event.data.reason);
      }
    });

    let obinfo = {
      "entityName":"Mktppref",
      "sql":`SELECT * FROM MKTPPREF WHERE NAME='mktp.oauth.marketplace.generic.config'`
    }         

    this.http.post(obinfo,'JsonBrokerServices/findnative',false,true,true).subscribe(conInfo=>{
        let info =  conInfo['SQL'][0];
        let jsonInfoOauth:Object[];
        try {
          jsonInfoOauth = JSON.parse(info['TEXT']);
        } catch (e) {
          console.error('Erro ao fazer parse da configuração OAuth (mktp.oauth.marketplace.generic.config):', e);
          console.error('Texto recebido:', info['TEXT']);
          return;
        }

        for ( var value of jsonInfoOauth){
            let ob:OAuthConfiguration = {
              codemktp:value['codemktp'],
              generic: true,
              urlAuth: value['urlAuth'],
              redirectUri: value['redirectUri'],
              name: value['name'],
              icon: value['icon']||'no-image',
              autenticado:false,
              expirado:false,
              tokenStatusService:value['tokenStatusService']||'OAuthServices/getTokenStatus',
              tokenGenerateService:value['tokenGenerateService']||'OAuthServices/generateToken'
            }
            this.marketplacelist.push(ob);
        }
    });

    this.interval = setInterval(()=>{
        if ( !this.selected || this.selected.checkData==false){
          return;
        }

        // Ativa estado waiting enquanto polling está ativo
        if (this.selected.checkData && !this.selected.waiting) {
            this.selected.waiting = true;
        }

        if  ( this.codemktp == 47 ){
          if ( this.selected.checkData ){
          
            let ob ={
              codecompany: this.codecompany.key,
              codemktp: this.codemktp,
              apptoken: this.appToken
  
          }
            this.sub = this.http.post(ob,'ShopeeNotifications/getTokenStatus',false,true,false).subscribe(data=>{
              if ( data["resultado"]){
                  
                    this.selected.checkData = false;
                    this.selected.waiting = false;
                    this.selected.autenticado = true;
                    this.selected.expirado = false;
                    this.selected.erro = false;
                    this.codemktp = null;
                    this.appToken = "";  
                    this.cd.markForCheck();
                    
                }
            });
          }
        }

        
        // if  ( this.codemktp == 62 ){
        //   if ( this.selected.checkData ){
          
        //     let ob ={
        //       codecompany: this.codecompany.key,
        //       codemktp: this.codemktp,
        //       apptoken: this.appToken
  
        //   }
        //     this.sub1 = this.http.post(ob,'AmazonServices/getTokenStatus',false,true,false,false).subscribe(data=>{
        //       if ( data["resultado"]){
                  
        //             this.selected.checkData = false;
        //             this.selected.waiting = false;
        //             this.selected.autenticado = true;
        //             this.selected.expirado = false;
        //             this.selected.erro = false;
        //             this.codemktp = null;
        //             this.appToken = "";  
        //             this.cd.markForCheck();                    
        //         }
        //     });
        //   }
        // }
        
        if  ( this.selected.generic && this.selected.tokenStatusService!=null){
          if ( this.selected.checkData ){
            let ob ={
              codecompany: this.codecompany.key,
              codemktp: this.codemktp,
              apptoken: this.appToken
  
            }

            this.sub3 = this.http.post(ob,this.selected.tokenStatusService,false,true,false,false).subscribe(data=>{
              if ( data["resultado"]){
                  
                    this.selected.checkData = false;
                    this.selected.waiting = false;
                    this.selected.autenticado = true;
                    this.selected.expirado = false;
                    this.selected.erro = false;
                    this.codemktp = "";
                    this.appToken = "";  
                    this.cd.markForCheck();                    
                }
            },error=>{
              this.selected.checkData = false;
              this.selected.autenticado = false;
              this.selected.expirado = false;
              this.selected.erro = true;
              throw error;
            });
          }
        }
      

    },3000);
  }

  autenticarV2(configuration:OAuthConfiguration, newAuth:boolean ){
    
    this.newAuth = newAuth;
    this.codemktp  = configuration.codemktp;

    this.selected = configuration;

    if ( configuration.additionalFields && configuration.additionalFields.length > 0){
        this.modalAdditionalFields = configuration.additionalFields;
        this.additionalForm = this.fb.group({});
        this.modalAdditionalFields.forEach(f => {
          this.additionalForm.addControl(f.name, new FormControl(null));
        });
        this.modalVisivel = true;
    }else{
      this.autenticar();
    }
    
  }
  
  async autenticar(){
    
    // if ( this.us.user.companylist.length > 1 ){
    //   if ( this.codecompany == null || this.codecompany==""){
    //     throw ("Para autenticar é necessário escolher uma empresa.");
    //   }
    // }else{
    //   this.codecompany = this.us.user.codecompany;
    // }

    if ( this.codecompany == null || this.codecompany.key==0 ){
        throw ("Para autenticar é necessário escolher uma empresa.");
    }
    
    if ( this.newAuth ){
      this.activecompanies = await this.createDataMktpActiveCompanies();
    }else{
      this.activecompanies = await this.createDataMktpActiveCompanies();
    }

    this.selected.waiting = true;
    this.selected.erro = false;
    
    if ( this.selected.generic ){
      
      if ( this.selected.tokenGenerateService) {
        let ob ={
          codecompany: this.codecompany.key,
          codemktp: this.codemktp
        }

        this.sub4 = this.http.post(ob,this.selected.tokenGenerateService,false,true,false).subscribe(data=>{

          if ( ObjectUtil.isNotEmpty(data['resultado']) ){
            this.selected.checkData = true;
            this.modalVisivel = false;
            this.appToken = data['resultado']['APPTOKEN'];
            this.url =  this.replaceVariables(this.selected.urlAuth,this.appToken);
            //(window as any).open(this.url,"_blank","noopener");
            window.open(
              this.url,
              "oauthWindow",
              "popup=yes,width=600,height=800,scrollbars=yes,resizable=yes"
            );

            this.cd.markForCheck();
          }else{
            throw ("Não encontrado configuração para a empresa "+ this.codecompany.key);
          }
        })
      }else{
          throw ("Não encontrado serviço");
      }
      
    }
    
    if ( this.codemktp == 121 ){
          if ( this.additionalForm ){
            this.username = this.additionalForm.get('username').value;
            this.password = this.additionalForm.get('password').value;
          }  
          
          if ( this.username!="" && this.password!=""){
            this.selected.checkData = true;
            let ob = {
              "type":"skw",
              "data":[
                  {
                      "codecompany":this.codecompany.key,
                      "username":this.username,
                      "password":this.password
                  }
            ]
          }
        
          this.sub4 = this.http.post(ob,'SystemServices/encryptData',false,true,false).subscribe(data=>{
            if ( data['data'][0].status=='1'){
              this.selected.checkData = false;
              this.selected.waiting = false;
              this.selected.autenticado = true;
              this.selected.expirado = false;
              this.selected.erro = false;
              this.modalVisivel = false;
              this.cd.markForCheck();
            }else{
              this.selected.checkData = false;
              this.selected.waiting = false;
              this.selected.autenticado = false;
              this.selected.expirado = false;
              this.selected.erro = true;
              throw Error(data['data'][0].mensagem);
            }
            
          },error=>{
              this.selected.checkData = false;
              this.selected.waiting = false;
              this.selected.autenticado = false;
              this.selected.expirado = false;
              this.selected.erro = true;
              throw error;
          });
        }else{
          this.selected.checkData = false;
          throw Error("Não encontrado codecompany ou codemktp");
        }
        
    }

    if ( this.codemktp == 47){
        
      let ob ={
          codecompany: this.codecompany.key,
          codemktp: this.codemktp
      }

      this.sub4 = this.http.post(ob,'ShopeeNotifications/generateToken',false,true,false).subscribe(data=>{

          if ( ObjectUtil.isNotEmpty(data['resultado']) ){
            this.selected.checkData = true;
            this.modalVisivel = false;
            let clientId:string = data['resultado']['ACESSTOKEN'];
            let redirectUrl = data['resultado']['REDIRECTURI'];
            let secredtKey = data['resultado']['SECRETKEY']; 
            let timestamp = Math.floor(Date.now()/1000);// new Date().getTime()/1000;
            let toEncrypt = clientId + '/api/v2/shop/auth_partner' + timestamp.toString();
            let sign = this.crypto.encryptSHA256(toEncrypt,secredtKey);

            let testMode = false;
            if ( this.additionalForm && this.additionalForm.get('testMode').value){
                testMode = this.additionalForm.get('testeMode').value;
            }

            if ( !testMode  ){
                this.url = "https://openplatform.shopee.com.br/api/v2/shop/auth_partner?partner_id="+clientId+"&timestamp="+timestamp+"&sign="+sign+"&redirect="+redirectUrl;
            }else{
                this.url = "https://partner.test-stable.shopeemobile.com/api/v2/shop/auth_partner?partner_id="+clientId+"&timestamp="+timestamp+"&sign="+sign+"&redirect="+redirectUrl;
            }
            (window as any).open(this.url,"_blank","noopener");
            this.cd.markForCheck();
          }else{
              this.selected.checkData = false;
              this.selected.waiting = false;
              this.selected.autenticado = false;
              this.selected.expirado = false;
              this.selected.erro = true;
            throw ("Não encontrado configuração para a empresa "+ this.codecompany.key);
          }
      },error=>{
            this.selected.checkData = false;
            this.selected.waiting = false;
            this.selected.autenticado = false;
            this.selected.expirado = false;
            this.selected.erro = true;
          throw error;
      })
    }

    // if ( this.codemktp == 62){

    //   if ( this.amazonprogramacode == 1){

    //       this.selected.checkData = false;

    //       let bodyDestination =JSON.stringify({
    //         "name": `${this.us.user.companylist.find(c=>c.codecompany == String(this.codecompany.key)).codecompany}`,
    //         "resourceSpecification":
    //         {
    //           "sqs":
    //           {
    //             "arn": this.activecompanies['ARNAMAZONNAME']
    //           }
    //         }
    //       });
  
    //       let accessToken = null;
    //       await this.AmazonServices.generateAmazonLWAAccessToken(this.activecompanies['CLIENT_ID_TOKEN'],this.activecompanies['CLIENT_SECRET'],'sellingpartnerapi::notifications',this.codecompany.key).then(data=>{
    //           accessToken = JSON.parse(data['resultado'])['access_token'];
    //       });

    //       let header = null;
    //       await this.AmazonServices.getHeader(
    //         'POST',
    //         'https://sellingpartnerapi-na.amazon.com/notifications/v1/destinations',
    //         accessToken,
    //         bodyDestination,
    //         this.activecompanies['SESSIONTOKEN'],
    //         this.codecompany.key,
    //         this.activecompanies
    //       ).then(data=>{
    //           header = data;
    //       });

    //       let ob = {
    //         "expressao": "getRequestData(Destinations,AmProAtivo,\"\",POST,{@BODY},{@HEADER},62)",
    //         "novo": true,
    //         "codecompany": this.codecompany.key,
    //         "codemktp": 62,
    //         "codecontract": 0,
    //         "values":[
    //           {
    //             'key':'@BODY',
    //             'value':bodyDestination
    //           },
    //           {
    //             'key':'@CODECOMPANY',
    //             'value':this.codecompany.key
    //           },
    //           {
    //             'key':'@CODEMKTP',
    //             'value':62
    //           },
    //           {
    //             'key':'@HEADER',
    //             'value':header
    //           },
    //           {
    //             "key":"newsplit",
    //             "value":true
    //           }
    //         ] 
    //       }
              
    //       this.sub = this.http.post(ob,'FormulaServices/test', true,true,false).subscribe(dest=>{
    //         let resultado = JSON.parse(dest['resultado']);
    //         let payLoad:Object = resultado['payload'];
    //         let destId = payLoad['destinationId'];

    //         this.criaSubscricao(destId,this.activecompanies['ACESSTOKEN']);

    //       },async (error:HttpErrorResponse)=>{
    //         if ( error.message.indexOf('Conflict')){
                  
    //             await this.AmazonServices.getHeader(
    //               'GET',
    //               'https://sellingpartnerapi-na.amazon.com/notifications/v1/destinations',
    //               accessToken,
    //               null,
    //               this.activecompanies['SESSIONTOKEN'],
    //               this.codecompany.key,
    //               this.activecompanies
    //             ).then(data=>{
    //                 header = data;
    //             });
    
    //             let ob = {
    //               "expressao": "getRequestData(Destinations,AmProAtivo,\"\",GET,null,{@HEADER},62)",
    //               "novo": true,
    //               "codecompany": this.codecompany.key,
    //               "codemktp": 62,
    //               "codecontract": 0,
    //               "values":[
    //                 {
    //                   'key':'@CODECOMPANY',
    //                   'value':this.codecompany.key
    //                 },
    //                 {
    //                   'key':'@CODEMKTP',
    //                   'value':62
    //                 },
    //                 {
    //                   'key':'@HEADER',
    //                   'value':header
    //                 },
    //                 {
    //                   "key":"newsplit",
    //                   "value":true
    //                 }
    //               ] 
    //             }
                
    //             this.sub = this.http.post(ob,'FormulaServices/test', true,true,false).subscribe(async dest=>{
    //               let resultado = JSON.parse(dest['resultado']);
    //               let payLoad:Object[] = resultado['payload'];
                  
    //               for ( var k of payLoad){
                    
    //                   if ( k['name'] == String(this.codecompany.key)){
    //                     let destId = k['destinationId'];
    //                     await this.criaSubscricao(destId,this.activecompanies['ACESSTOKEN']);
    //                     break;
    //                   }
    //               } 
    //           },(error:HttpErrorResponse)=>{
                
    //               this.selected.checkData = false;
    //               this.selected.waiting = false;
    //               this.selected.autenticado = false;
    //               this.selected.expirado = false;
    //               this.selected.erro = true;
    //                 throw error;
                
    //           },()=>{
    //           });
    //         }else{
    //           this.selected.checkData = false;
    //           this.selected.waiting = false;
    //           this.selected.autenticado = false;
    //           this.selected.expirado = false;
    //           this.selected.erro = true;
    //           throw error;
    //         }

    //       })
          
    //   }else{
    //     let ob ={
    //       codecompany: this.codecompany.key,
    //       codemktp: this.codemktp
    //     }
  
    //     this.sub5 = this.http.post(ob,'AmazonServices/generateToken',false,true,false).subscribe(data=>{

    //       if ( ObjectUtil.isNotEmpty(data['resultado']) ){
    //         this.selected.checkData = true;
    //         let clientId = data['resultado']['APIKEY'];
    //         this.nickname = data['resultado']['NICKNAME'];
    //         this.url =  "https://sellercentral.amazon.com.br/apps/authorize/consent?application_id="+clientId+"&state="+this.nickname;
    //         (window as any).open(this.url,"_blank");

    //         this.cd.markForCheck();
    //       }else{
    //         this.selected.checkData = false;
    //         this.selected.waiting = false;
    //         this.selected.autenticado = false;
    //         this.selected.expirado = false;
    //         this.selected.erro = true;
    //         throw ("Não encontrado configuração para a empresa "+ this.codecompany.key);
    //       }
    //     },error=>{
    //           this.selected.checkData = false;
    //           this.selected.waiting = false;
    //           this.selected.autenticado = false;
    //           this.selected.expirado = false;
    //           this.selected.erro = true;
    //         throw error;
    //     });
    //   }    
    // }
  }
  
  
  async criaSubscricao(destId: any, accessToken: any ) {
      
    let header = null;

    let bodySubscription =JSON.stringify({
      "payloadVersion": "1.0",
      "destinationId": destId});

    await this.AmazonServices.getHeader(
        'POST',
        'https://sellingpartnerapi-na.amazon.com/notifications/v1/subscriptions/FBA_OUTBOUND_SHIPMENT_STATUS',
        accessToken,
        bodySubscription,
        this.activecompanies['SESSIONTOKEN'],
        this.codecompany.key,
        this.activecompanies
      ).then(data=>{
          header = data;
      });

      let ob = {
        "expressao": "getRequestData(SubscriptionAnyOfferChanged,AmProAtivo,\"\",POST,{@BODY},{@HEADER},62)",
        "novo": true,
        "codecompany": this.codecompany.key,
        "codemktp": 62,
        "codecontract": 0,
        "values":[
          {
            'key':'@BODY',
            'value':bodySubscription
          },
          {
            'key':'@CODECOMPANY',
            'value':this.codecompany.key
          },
          {
            'key':'@CODEMKTP',
            'value':62
          },
          {
            'key':'@HEADER',
            'value':header
          },
          {
            "key":"newsplit",
            "value":true
          }
        ] 
      }
      
      this.sub = this.http.post(ob,'FormulaServices/test', true,true,false).subscribe(dest=>{
        
        let resultado = JSON.parse(dest['resultado']);
        let payLoad:Object = resultado['payload'];
        this.selected.checkData = false;        
        this.selected.waiting = false;
        this.selected.autenticado = true;
        this.selected.expirado = false;
        this.selected.erro = false;        
        this.codecompany = null;
        this.codemktp = "";
        this.cd.markForCheck();
    },(error:HttpErrorResponse)=>{
        throw error;
    },()=>{
    });
  }

  replaceVariables(url:string,appToken: string){

    let reg: RegExpMatchArray = url.match(/{@(.*?)}/g);
    if (reg != null) {
      reg.forEach(d=>{
        let fieldName = d.replace("{@", "").replace("}", "");
        if ( fieldName == "APPTOKEN"){
          url = url.replace(d,appToken);
        }else{
          let newValue = this.activecompanies[fieldName];
          url = url.replace(d,newValue)
        }
      })
    }
    return url;
  }

  /// novos componentes // 
  marketplaceSelecionado:any = null;
  modalAdditionalFields:OAuthAdditionalFields[] = [];
  loading:boolean =false;
  modalVisivel:boolean = false;
  additionalForm:FormGroup;
  selected:OAuthConfiguration;
  newAuth:boolean = false;
  
  fecharModal(){
      this.additionalForm = this.fb.group({});
      this.modalAdditionalFields = [];
      this.modalVisivel = false;
      this.selected = null;
  }

  cancelarAutenticacao(marketplace: OAuthConfiguration){
      if (marketplace){
          marketplace.checkData = false;
          marketplace.waiting = false;
          marketplace.erro = true;
          this.cd.markForCheck();
      }
  }



  searchInputCodeCompany:SearchProperties ={
          entityName:'Mktpcompanies',
          fields:{keyField:'CODECOMPANY', valueField:'NAME'},
          placeholder:this.ls.instant("CODECOMPANY"),
          showKey:true,
          size:'default',
          disabled:false
  }

  filtros = [
  { key: 'autenticado', label: 'Autenticados', checked: true },
  { key: 'naoAutenticado', label: 'Não Autenticados', checked: true },
  { key: 'expirado', label: 'Expirados', checked: true },
  { key: 'erro', label: 'Com Erro', checked: true }
  ];

  marketplacesFiltrados = [];
  searchMarketplace: string = '';


  aplicarFiltros() {
    if (this.codecompany == null || this.codecompany.key == 0){
      this.marketplacesFiltrados = [];
      return;
    }

    const ativos = this.filtros.filter(f => f.checked).map(f => f.key);
    const searchTerm = this.searchMarketplace?.toLowerCase().trim() || '';

    let filtered = this.marketplacelist;

    // Filtro por status
    if (ativos.length > 0) {
      filtered = filtered.filter(m => {
        return ativos.some(f => {
          if (f === 'autenticado') return m.autenticado === true && m.expirado == false;
          if (f === 'naoAutenticado') return m.autenticado === false || m.autenticado == null;
          if (f === 'expirado') return m.autenticado === true && m.expirado === true;
          if (f === 'erro') return m.erro === true;
          return false;
        });
      });
    }

    // Filtro por nome ou código
    if (searchTerm) {
      filtered = filtered.filter(m => 
        m.name?.toLowerCase().includes(searchTerm) || 
        m.codemktp?.toString().includes(searchTerm)
      );
    }

    this.marketplacesFiltrados = filtered;
  }

  changingCompany(evento: any){
    this.loading = true;
    this.loadingData();
  }

  loadingData(){
    return new Promise((resolve,reject)=>{
        let ob = {
            entityName:'Mktpactivecompanies',
            sql: `SELECT CODECOMPANY,
                         CODEMKTP,
                         STATUS,
                         EXPIRESIN
                  FROM VW_ACTIVECOMPANIES
                  WHERE CODECOMPANY IN (${this.us.getCompanies()})
                  AND CODECOMPANY = ${this.codecompany.key}`
        }  

        this.http.post(ob,'JsonBrokerServices/findnative',false,
          true,false,false
        ).subscribe({
            next:((value:any)=>{
                if ( value && value.SQL){
                  let activeCompanies = value.SQL;
                     
                    this.marketplacelist.forEach(d => {
                    const comp = activeCompanies.find((x: { [x: string]: number; }) => x['CODEMKTP'] == d.codemktp);

                    d.autenticado = false;
                    d.expirado = false;

                    if (comp && d.codemktp && comp['STATUS'] === '1') {
                      d.autenticado = true;

                      const expiresStr = comp['EXPIRESIN']; 
                      
                      if (expiresStr) {
                        const expiresTime = new Date(expiresStr.replace(' ', 'T')).getTime();
                        d.expirado = expiresTime < Date.now();
                      }else{
                        d.erro = true;
                      }

                    }
                  });

                  this.aplicarFiltros();
                }
                resolve(true);
                this.loading  = false;
            }),
         error:(err)=>{
            this.loading  = false;
            throw err;
         }})
     });
  }

  createDataMktpActiveCompanies() {
      let ob = {
          codecompany: this.codecompany.key,
          codemktp: this.codemktp,
          newAuth: this.newAuth
      }

      return new Promise((resolve,reject)=>{
          this.http.post(ob,'OAuthServices/generateRegistry',false,true,false).subscribe({
              next:((value:any)=>{
                  resolve(value);
              }), 
              error:(err)=>{
                  this.selected.checkData = false;
                  reject(err);
              }
          });
      });
  }

}


